import {Module} from "vuex";

/**
 * 项目案例-工地
 * @type {Module}
 */
export const construction = {
        namespaced: true,
        state: {
            // 用户头像类型
            userHeadImageList: [
                {
                    type: '1',
                    image: require('@/assets/images/project-detail/userHead/1.png'),
                    name: '监理',
                },
                {
                    type: '2',
                    image: require('@/assets/images/project-detail/userHead/2.png'),
                    name: '签单员',
                },
                {
                    type: '3',
                    image: require('@/assets/images/project-detail/userHead/3.png'),
                    name: '施工员',
                },
                {
                    type: '4',
                    image: require('@/assets/images/project-detail/userHead/4.png'),
                    name: '项目经理',
                },
                {
                    type: '5',
                    image: require('@/assets/images/project-detail/userHead/5.png'),
                    name: '制图师',
                }
            ],
            // 验收点弹窗渲染列表
            arrInspectPopupList: [
                {
                    title: "水力模块",
                    inspectContent: [
                        {
                            content: "室内机冷凝水是否按坡度要求接入冷凝水排水管",
                            isOk: true,
                        },
                        {
                            content: "室内机安装牢固可靠，安装环境温度是否＞0℃",
                            isOk: true,
                        },
                        {
                            content: "吊顶式室内机顶部安装是否满足安装要求",
                            isOk: true,
                        },
                        {
                            content: "壁挂式室内机顶部安装是否满足安装要求",
                            isOk: true,
                        },
                        {
                            content: "室内机接管侧预留电源，线路连接是否正确（接线正确，线有保护管，无铜裸露）",
                            isOk: true,
                        },
                        {
                            content: "吊顶式水力模块泄压阀、排气阀是否安装",
                            isOk: true,
                        },
                    ],
                },
                {
                    title: "风机盘管",
                    inspectContent: [
                        {
                            content: "风机盘管安装是否有防松脱措施（下部固定是否采用双螺母或采用螺母加弹簧垫圈）",
                            isOk: true,
                        },
                        {
                            content: "风机盘管吊装丝杆是否≥M8，长度是否超过机器下沿",
                            isOk: true,
                        },
                        {
                            content: "风机盘管安装顶部与顶面之间是否有隔振措施（增加橡胶减震垫及与顶面之间至少预留5mm的间隙)",
                            isOk: true,
                        },
                        {
                            content: "风机盘管是否采取了防尘保护（防止后期装修灰层进入风盘）",
                            isOk: true,
                        },
                        {
                            content: "风机盘管出风口帆布软接与机器之间是否采用压条可靠固定",
                            isOk: true,
                        },
                        {
                            content: "风机盘管的安装位置是否符合标准（出风口前不宜有灯槽阻挡，避免风机盘管出回风气流短路等）",
                            isOk: true,
                        },
                        {
                            content: "风盘帆布是否满足防水、防霉保温防凝露，阻燃V0级要求，宽度150-250mm",
                            isOk: true,
                        },
                        {
                            content: "下送下回送回风口之间的中心距是否大于 1200mm，未造成气流短路",
                            isOk: true,
                        },
                        {
                            content: "风机盘管与管道之间是否采用波纹软管连接 ",
                            isOk: true,
                        },
                        {
                            content:
                                "风机盘管检修空间是否满足设计要求（预留检修空间，检修阀件均在检修空间内，检修口做好标识）检回一体时，回风口应朝接管侧方向延长300mm 以上，宽度不得低于250mm；单独设置检修口达到400*400mm",
                            isOk: true,
                        },
                        {
                            content:
                                "若安装3D送风装置，非接管侧按需求预留空间（制冷功率＜5.0kw，预留≥140mm；制冷功率≥5.0kW，预留≥180mm）；若安装普通风口，预留≥100mm ",
                            isOk: true,
                        },
                        {
                            content:
                                "若安装3D送风装置，非接管侧按需求预留空间（制冷功率＜5.0kw，预留≥140mm；制冷功率≥5.0kW，预留≥180mm）；若安装普通风口，预留≥100m ",
                            isOk: true,
                        },
                        {
                            content: "风机盘管是否预留电源，线路连接是否正确（接线正确，线有保护管，无铜裸露） ",
                            isOk: true,
                        },
                        {
                            content: "温控面板是否预留电源 ",
                            isOk: true,
                        },
                    ],
                },
                {
                    title: "主管",
                    inspectContent: [
                        {
                            content: "管道吊杆的材料是否规范（不能用铁丝，塑料带等充当吊杆，吊杆需≥M8）",
                            isOk: true,
                        },
                        {
                            content: "室内机至风机盘管的连接管道吊架间距不大于1.2m设置支吊架",
                            isOk: true,
                        },
                        {
                            content: "最远端风机盘管、地暖盘管分集水器前是否安装公司指定或经公司备案压差旁通，压差旁通安装方向是否为供水管至回水管方向",
                            isOk: true,
                        },
                        {
                            content: "电动两通阀执行器是否高于阀门水平线安装，电动两通阀是否是公司的或经过公司备案",
                            isOk: true,
                        },
                        {
                            content: "所有管道的走向是否做到横平竖直，美观整齐，进出水管标识清晰",
                            isOk: true,
                        },
                        {
                            content: "管路布置是否有遮挡设备检修口",
                            isOk: true,
                        },
                    ],
                },
                {
                    title: "冷凝水",
                    inspectContent: [
                        {
                            content: "冷凝水管管径和管材是否根据风机盘管容量和台数合理选择（不得小于DN25）（不能使用电线管充当冷凝水管）",
                            isOk: true,
                        },
                        {
                            content: "每台风机盘管冷凝水管是否独立设置通气口、冷凝水汇流管长度＞6m 是否设置通气口",
                            isOk: true,
                        },
                        {
                            content: "冷凝水管坡度设置是否合理",
                            isOk: true,
                        },
                        {
                            content: "冷凝水管通气口的开口方向不能朝上或有防尘帽，防止异物进入阻塞 ",
                            isOk: true,
                        },
                        {
                            content: "冷凝水管排水口不能直接接入污水管（如厨房间、卫生间下水管道）",
                            isOk: true,
                        },
                        {
                            content: "冷凝水主管汇流连接是否正确（汇流处应错位连接，不能“T”接） ",
                            isOk: true,
                        },
                        {
                            content: "风机盘管辅助排水软管是否保持平直（不能弯曲或当作弯头使用） ",
                            isOk: true,
                        },
                        {
                            content: "冷凝水管的吊杆间距是否符合标准（间距 0.8-1m）  ",
                            isOk: true,
                        },
                    ],
                },
                {
                    title: "其他",
                    inspectContent: [
                        {
                            content: "壁挂炉、室内机、风机盘管、温控器、分集水器所预留的电源是否来自同一相位，如果不是，是否用跨相器请记录不同设备电源所在相位",
                            isOk: true,
                        },
                        {
                            content: "现场管道直径、走向、坡度、蓄能水箱与膨胀罐等是否按照设计图纸进行",
                            isOk: true,
                        },
                        {
                            content: "水泵安装是否正确，是否远离噪音敏感区域（如卧室、办公室等）",
                            isOk: true,
                        },
                        {
                            content: "壁挂炉是否正确连接入系统，派型三通是否正确，派型三通距壁挂炉管长是否大于50cm  ",
                            isOk: true,
                        },
                        {
                            content: "系统是否正确设置自动排气措施，微泡出气口连接有排水导管至排水设施 ",
                            isOk: true,
                        },
                        {
                            content: "现场施工人员是否着装规范，佩戴工作牌 ",
                            isOk: true,
                        },
                        {
                            content: "现场是否张贴施工工艺方面的相关告示，现场是否张贴管道系统，风口尺寸等相关标识  ",
                            isOk: true,
                        },
                        {
                            content: "电源线布置是否按公司图纸要求，接线是否正确，是否有套管保护（不建议星形连接）",
                            isOk: true,
                        },
                        {
                            content: "艾暖通信息回馈是否正确及时 ",
                            isOk: true,
                        },
                    ],
                },
                {
                    title: "试水保压",
                    inspectContent: [
                        {
                            content: "冷凝水是否进行每台内机100%通水试验，并排水顺畅",
                            isOk: true,
                        },
                        {
                            content:
                                "是否按正确步骤打压：系统打压至0.4MPa，观察设备及各接口是否有泄漏；若无，则隔离开室内机，继续打压至0.6MPa，观察1小时，压降≤0.05MPa判定合格",
                            isOk: true,
                        },
                    ],
                },
                {
                    title: "保温",
                    inspectContent: [
                        {
                            content:
                                "主管及支管保温是否符合规范要求（保温过程中无管道露出；穿越孔洞时孔洞内管道保温完好；若特殊区域无法满足正常保温空洞要求，至少9mm保温，并发泡打实。）",
                            isOk: true,
                        },
                        {
                            content: "所有阀件、水泵是否保温符合规范要求（所有阀件均需保温，阀头处用保温套管包裹，离心泵用接水盘且有保温）",
                            isOk: true,
                        },
                        {
                            content: "水箱螺栓内是否打发泡保温 ",
                            isOk: true,
                        },
                        {
                            content: "保温交界处是否采用胶黏并用保温层包裹；保温吊码是否内村宽塑料件",
                            isOk: true,
                        },
                    ],
                },
            ],
            // 展开索引
            arrOpenCategoryKey: [],
            // 大类目数组
            arrCategoryList: [
                {
                    name: "进场定位", // 品名
                    nameKey: '',
                    key: "position",
                    icon: require("@/assets/images/project-detail/dingwei.png"),
                    builder: [],
                    siteLabeling: [],
                    isEnd: true, // 完工
                },
                {
                    name: "空调施工", // 品名
                    nameKey: 2,
                    key: "ari",
                    icon: require("@/assets/images/project-detail/kongtiao.png"),
                    builder: [{}],
                    siteLabeling: [],
                    inspectResult: [],
                    userEvaluate: {
                        evaTags: ["服务专业", "验收及时"], // 评论标签
                        evaScore: 5, // 评分
                        evaContext: "施工严谨，施工时未监工,觉得史密斯是大公司，就特别信任", // 评论内容
                        time: "2021.12.16", // 评论时间
                        score: "5.0",
                        mateResult: [
                            // 媒体资源
                            {
                                img: require("@/assets/images/project-detail/0008-test.png"),
                                type: "image",
                            },
                            {
                                img: require("@/assets/images/project-detail/0008-test.png"),
                                type: "video",
                            },
                            {
                                img: require("@/assets/images/project-detail/0008-test.png"),
                                type: "image",
                            },
                        ],
                        audioTime: 50, // 语音时长
                    }, // 评论信息
                    isEnd: true, // 完工
                },
                {
                    name: "采暖施工", // 品名
                    nameKey: 3,
                    icon: require("@/assets/images/project-detail/cainuan.png"),
                    key: "sun",
                    builder: [],
                    siteLabeling: [],
                    isEnd: true, // 完工
                },
                {
                    name: "新风施工", // 品名
                    nameKey: 7,
                    key: "wind",
                    icon: require("@/assets/images/project-detail/xinfen.png"),
                    isEnd: false, // 完工
                },
                {
                    name: "设备安装系统调试", // 品名
                    nameKey: 8,
                    key: "system",
                    icon: require("@/assets/images/project-detail/xitong.png"),
                    isEnd: false, // 完工
                },
                {
                    name: "安装效果", // 品名
                    nameKey: 9,
                    key: "effect",
                    icon: require("@/assets/images/project-detail/anzhuang.png"),
                    isEnd: false, // 完工
                },
            ],
            // 路由位置
            objRouterPosition: {
                construction: 0,
                custom: 0,
                evaluation: 0,
                team: 0,
            },
            // 入口实例
            objIndexPageRef: null,
        },
        mutations: {
            /**
             * 设置验收弹窗
             * @constructor
             */
            CHANGE_ARR_INSPECT(state, typeAction) {
                state.arrInspectPopupList = typeAction.list;
            },
            /**
             * 保存入口页面实例
             * @param state
             * @param typeAction
             * @constructor
             */
            SAVE_INDEX_PAGE_REF(state, typeAction) {
                state.objIndexPageRef = typeAction.ref;
            },
            /**
             * 改变分类标签激活状态
             * @param state
             * @param typeAction
             * @constructor
             */
            CHANGE_CATEGORY_LABEL_STATE(state, typeAction) {
                const {categoryKey, labelId, activeTagKey} = typeAction;
                state.arrCategoryList = state.arrCategoryList.map((category) => {
                    if (category.key === categoryKey) {
                        category.siteLabeling = category.siteLabeling.map((label) => {
                            if (label.labelId === labelId) {
                                label.switchTag = label.switchTag.map((tag) => {
                                    tag.active = tag.key === activeTagKey;
                                    return tag;
                                });
                            }
                            return label;
                        });
                    }
                    return category;
                });
            },
            /**
             * 改变展开项
             * @param state
             * @param typeAction
             * @constructor
             */
            CHANGE_CATEGORY_OPEN_KEY(state, typeAction) {
                const {key} = typeAction;

                // 添加一个匹配是否完工的条件
                const isEnd = state.arrCategoryList.find((i) => i.key === key)?.isEnd;
                if (!isEnd) return;

                const hasKey = state.arrOpenCategoryKey.includes(key);

                if (hasKey) {
                    state.arrOpenCategoryKey = state.arrOpenCategoryKey.filter(i => i !== key);
                } else {
                    state.arrOpenCategoryKey.push(key);
                }

                // state.arrOpenCategoryKey = hasKey ? [] : [key];
            },
            /**
             * 储存路由离开时的位置
             * @param state
             * @param typeAction
             * @constructor
             */
            SAVE_ROUTER_POSITION(state, typeAction) {
                const {routerType, val} = typeAction;
                state.objRouterPosition[routerType] = val;
            },
            /**
             * 整理大类目数组
             * @param state
             * @param typeAction
             * @constructor
             */
            MAP_CATEGORY_LIST(state, typeAction) {
                state.arrCategoryList = typeAction.list.map((cate) => {
                        const target = state.arrCategoryList.find(i => cate.name.includes(i.name));
                        // 控制默认展开情况
                        target && state.arrOpenCategoryKey.push(target.key);
                        const siteLabeling = cate.lists.map(site => {
                            const decimal = {};
                            const switchTag = site.lists.map((tag, index) => {
                                const result = {name: tag.title, active: index === 0, key: tag.id};
                                decimal[result.key] = {
                                    contentList: tag.selling_lists.map(i => i.selling_point_title),
                                    siteLive: tag.images.map(i => ({img: i.image_url, key: i.index})),
                                    siteStandard: [{img: tag.standard_photograph_url, key: 0}],
                                }
                                return result;
                            });



                            if (site.selling_lists) {
                                decimal.default = {
                                    contentList: site.selling_lists.map(i => i.selling_point_title),
                                    siteLive: site.image_lists.map(i => ({img: i.img, key: i.index})),
                                    siteStandard: [{img: site.standard_photograph_url, key: 0}], // wutag缺施工标准图
                                }
                            }

                            return {
                                title: site.name,
                                labelId: site.id,
                                switchTag, decimal,
                            }
                        });

                        const builder = cate.work.map(i => {
                            const {name, job_number, rel_group_name, certification, icon, score} = i;
                            return {
                                ...target?.builder,
                                name,
                                headImage: icon,
                                evaValue: score,
                                no: job_number,
                                score: score?.toFixed(1) ?? 0,
                                job: rel_group_name,
                                aptitudeList: certification?.length ? certification : [
                                    {
                                        name: '系统家电施工资质',
                                        icon: require('@/assets/images/project-detail/default-icon.png')
                                    }
                                ]
                            }
                        });

                        const {info: {job_number, name, rel_group_name, score, icon} = {}, lists, state: isOk, group, rel_new_name, created_at} = cate.acceptance;
                        // 验收员
                        const supervision = {
                            ...target?.supervision,
                            title: rel_new_name,
                            name, no: job_number, score: score?.toFixed(1),
                            job: rel_group_name,
                            headImage: icon,
                            evaValue: score,
                            time: created_at,
                            isOk,
                        };

                        // 验收数据表
                        const inspectResult = group?.map(({cate_name: point, qualified_total: numUtil, total: pointUtil}) => ({point, numUtil, pointUtil})) || []

                        // 验收弹窗内容
                        console.log(lists,'---->')
                        const arrInspectPopupList = [{
                            title: '',
                            inspectContent: lists?.map(({new_name, is_right}) => ({
                                content: new_name,
                                isOk: is_right,
                            }))
                        }]
                        return {
                            ...target,
                            siteLabeling,
                            builder,
                            supervision,
                            inspectResult,
                            arrInspectPopupList,
                            isEnd: !!cate.is_reach,
                            arrInspect: !!lists?.length,
                        };
                    }
                )


            }
        },
        actions: {}
        ,
        getters: {}
        ,
    }
;
